import React, { useState } from "react";

export type Props = {
  defaultActive?: number;
  tabList: {
    title: string;
  }[];

  panelList: { panel: object }[];
  onChangeTapState: (index: number) => any;
};
const Tab: React.FC<Props> = (props) => {
  const { tabList, panelList, defaultActive = "0", onChangeTapState } = props;
  const [active, setActive] = useState(defaultActive || 0);
  const changeTab = (index: number) => {
    setActive(index);

    console.log("change tab!!", props);
    onChangeTapState(index);
    // props.onChangeTapState(index);
  };
  console.log("panelList", panelList[0]);

  return (
    <div>
      <div className="tabs">
        {tabList?.map((child, index) => {
          return (
            <div
              className={`tabs-container ${active == index ? "active" : ""} `}
              key={index}
              onClick={() => changeTab(index)}
            >
              {child.title}
            </div>
          );
        })}
      </div>
      <div style={{ marginTop: "20px" }}>{panelList[Number(active)].panel}</div>
    </div>
  );
};
export default Tab;
